// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
.turing-ui-v2-instack-demand-other-modal {
  width: 618px !important;

  .ant-modal-content {
    border-radius: 10px;
    overflow: hidden;
  }

  .turing-ui-v2-instack-demand-other-modal-container {
    display: flex;

    .ant-card-body {
      padding: 40px;

      h4.ant-typography, .ant-typography h4 {
        margin: unset;
        color: #444444;
        font-weight: 400;
        letter-spacing: 0;
        font-size: 20px;
        margin-bottom: 1.7142857142857142rem;
      }

      .select-main-language {
        padding-top: 1.8571428571428572rem;
      }

      h5.ant-typography, .ant-typography h5 {
        margin-bottom: 0.5em;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 600;
        font-size: 16px;
        line-height: 1.4;
      }

      .InStackDemandOtherSelector {
        display: flex;
        flex-wrap: wrap;
        grid-gap: 5px;
        margin-top: 24px;
      }

      .InStackDemandItem {
        background: #f4f4f4 0% 0% no-repeat padding-box !important;
        border-radius: 50px !important;
        opacity: 1 !important;
        padding: 6px 12px;
      }

      .ant-tag-checkable-checked.InStackDemandItem {
        color: #fff !important;
        background: #666666 0% 0% no-repeat padding-box !important;
      }

      .select-skills {
        padding-top: 2.857142857142857rem;
      }

      .additional-skills {
        padding-top: 1.7142857142857142rem;

        .ant-select-selection--multiple .ant-select-selection__rendered {

          & > ul > li.ant-select-selection__choice {
            border-radius: 50px;
            background: #4444440F 0% 0% no-repeat padding-box;
            color: #444444;
            font-size: 12px;
          }
        }
      }

      .after-commiting-warning {
        padding-top: 1.7142857142857142rem;
      }

      .modal-actions {
        padding-top: 2.857142857142857rem;

        .ant-btn {
          margin-left: 8px;
        }
      }
    }
  }
}
*/

.turing-ui-v2-instack-demand-other-modal {
  width: 618px !important;
}
.turing-ui-v2-instack-demand-other-modal .ant-modal-content {
  border-radius: 10px;
  overflow: hidden;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container {
  display: flex;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body {
  padding: 40px;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body h4.ant-typography, .turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .ant-typography h4 {
  margin: unset;
  color: #444444;
  font-weight: 400;
  letter-spacing: 0;
  font-size: 20px;
  margin-bottom: 1.7142857143rem;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .select-main-language {
  padding-top: 1.8571428571rem;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body h5.ant-typography, .turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .ant-typography h5 {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 16px;
  line-height: 1.4;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .InStackDemandOtherSelector {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 5px;
  margin-top: 24px;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .InStackDemandItem {
  background: #f4f4f4 0% 0% no-repeat padding-box !important;
  border-radius: 50px !important;
  opacity: 1 !important;
  padding: 6px 12px;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .ant-tag-checkable-checked.InStackDemandItem {
  color: #fff !important;
  background: #666666 0% 0% no-repeat padding-box !important;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .select-skills {
  padding-top: 2.8571428571rem;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .additional-skills {
  padding-top: 1.7142857143rem;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .additional-skills .ant-select-selection--multiple .ant-select-selection__rendered > ul > li.ant-select-selection__choice {
  border-radius: 50px;
  background: #4444440F 0% 0% no-repeat padding-box;
  color: #444444;
  font-size: 12px;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .after-commiting-warning {
  padding-top: 1.7142857143rem;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .modal-actions {
  padding-top: 2.8571428571rem;
}
.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .modal-actions .ant-btn {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/InStackDemandOtherSelector/InStackDemandOtherSelectorModal.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAuFC;;AAED;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,0DAA0D;EAC1D,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/*\n.turing-ui-v2-instack-demand-other-modal {\n  width: 618px !important;\n\n  .ant-modal-content {\n    border-radius: 10px;\n    overflow: hidden;\n  }\n\n  .turing-ui-v2-instack-demand-other-modal-container {\n    display: flex;\n\n    .ant-card-body {\n      padding: 40px;\n\n      h4.ant-typography, .ant-typography h4 {\n        margin: unset;\n        color: #444444;\n        font-weight: 400;\n        letter-spacing: 0;\n        font-size: 20px;\n        margin-bottom: 1.7142857142857142rem;\n      }\n\n      .select-main-language {\n        padding-top: 1.8571428571428572rem;\n      }\n\n      h5.ant-typography, .ant-typography h5 {\n        margin-bottom: 0.5em;\n        color: rgba(0, 0, 0, 0.85);\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 1.4;\n      }\n\n      .InStackDemandOtherSelector {\n        display: flex;\n        flex-wrap: wrap;\n        grid-gap: 5px;\n        margin-top: 24px;\n      }\n\n      .InStackDemandItem {\n        background: #f4f4f4 0% 0% no-repeat padding-box !important;\n        border-radius: 50px !important;\n        opacity: 1 !important;\n        padding: 6px 12px;\n      }\n\n      .ant-tag-checkable-checked.InStackDemandItem {\n        color: #fff !important;\n        background: #666666 0% 0% no-repeat padding-box !important;\n      }\n\n      .select-skills {\n        padding-top: 2.857142857142857rem;\n      }\n\n      .additional-skills {\n        padding-top: 1.7142857142857142rem;\n\n        .ant-select-selection--multiple .ant-select-selection__rendered {\n\n          & > ul > li.ant-select-selection__choice {\n            border-radius: 50px;\n            background: #4444440F 0% 0% no-repeat padding-box;\n            color: #444444;\n            font-size: 12px;\n          }\n        }\n      }\n\n      .after-commiting-warning {\n        padding-top: 1.7142857142857142rem;\n      }\n\n      .modal-actions {\n        padding-top: 2.857142857142857rem;\n\n        .ant-btn {\n          margin-left: 8px;\n        }\n      }\n    }\n  }\n}\n*/\n\n.turing-ui-v2-instack-demand-other-modal {\n  width: 618px !important;\n}\n.turing-ui-v2-instack-demand-other-modal .ant-modal-content {\n  border-radius: 10px;\n  overflow: hidden;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container {\n  display: flex;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body {\n  padding: 40px;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body h4.ant-typography, .turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .ant-typography h4 {\n  margin: unset;\n  color: #444444;\n  font-weight: 400;\n  letter-spacing: 0;\n  font-size: 20px;\n  margin-bottom: 1.7142857143rem;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .select-main-language {\n  padding-top: 1.8571428571rem;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body h5.ant-typography, .turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .ant-typography h5 {\n  margin-bottom: 0.5em;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.4;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .InStackDemandOtherSelector {\n  display: flex;\n  flex-wrap: wrap;\n  grid-gap: 5px;\n  margin-top: 24px;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .InStackDemandItem {\n  background: #f4f4f4 0% 0% no-repeat padding-box !important;\n  border-radius: 50px !important;\n  opacity: 1 !important;\n  padding: 6px 12px;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .ant-tag-checkable-checked.InStackDemandItem {\n  color: #fff !important;\n  background: #666666 0% 0% no-repeat padding-box !important;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .select-skills {\n  padding-top: 2.8571428571rem;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .additional-skills {\n  padding-top: 1.7142857143rem;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .additional-skills .ant-select-selection--multiple .ant-select-selection__rendered > ul > li.ant-select-selection__choice {\n  border-radius: 50px;\n  background: #4444440F 0% 0% no-repeat padding-box;\n  color: #444444;\n  font-size: 12px;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .after-commiting-warning {\n  padding-top: 1.7142857143rem;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .modal-actions {\n  padding-top: 2.8571428571rem;\n}\n.turing-ui-v2-instack-demand-other-modal .turing-ui-v2-instack-demand-other-modal-container .ant-card-body .modal-actions .ant-btn {\n  margin-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
